import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Locations from "@/pages/Locations";
import Apply from "@/pages/Apply";
import Employers from "@/pages/Employers";
import Admin from "@/pages/Admin";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/locations" element={<Layout><Locations /></Layout>} />
        <Route path="/apply" element={<Layout><Apply /></Layout>} />
        <Route path="/employers" element={<Layout><Employers /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
